import { animate, style, transition, trigger } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { loadComponentTranslations } from '../../funcs/lang-loader';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-how-it-work',
  imports: [TranslateModule],
  templateUrl: './how-it-work.component.html',
  styleUrl: './how-it-work.component.scss',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('1s ease-in-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('1s ease-in-out', style({ opacity: 0, transform: 'translateY(-20px)' }))
      ])
    ])
  ]
})
export class HowItWorkComponent implements OnInit {

  steps = [
    { title: '1. Sign Up', icon: 'fa-user-plus', description: 'Create your account and set up your preferences.' },
    { title: '2. Create Appointment Type', icon: 'fa-calendar-alt', description: 'Define the types of appointments your business offers.' },
    { title: '3. Set Up Availability', icon: 'fa-clock', description: 'Configure available time slots for your clients.' },
    { title: '4. Book, Manage & Optimize', icon: 'fa-tasks', description: 'Accept bookings and manage appointments seamlessly.' }
  ];




  visibleSteps: number = 0;

  constructor(private _changeDetectRef: ChangeDetectorRef,
    private _translateService: TranslateService,
    private _http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,

  ) {

  }
  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  public ngOnInit(): void {
    let lang = this._translateService.currentLang || 'en';

    this._http.get<any>('./assets/i18n/static-content/how-it-works-steps.json')
      .subscribe({
        next: res => {
          this.steps = res[lang]?.['steps'];
        }
      });

    loadComponentTranslations(this._http, this._translateService, 'controls/how-it-work', this.isBrowser())
      .subscribe({
        next: () => {

        },
        error: () => {

        }
      });
  }



}
